import React, { useState, useEffect, useContext, Fragment } from "react";
import StateTable from "./stateTable";
import { getAPI, putpost, masterServiceBaseUrl } from "services/http";

import { PermissionContext, RolePermissions } from "appContext";
import { PermisionDenied } from "../../common/commonComponents";
import CustomLoader from "../../common/commonComponents/Loader/loader";
import { pages } from "../../common/constant";
import {
  failureToast,
  successToast,
} from "../../common/utils/methods/toasterFunctions/function";

const State = () => {
  const [apiloader, setapiloader] = useState(false);
  const [state, setstate] = useState([]);
  const [isSaveVisible, setisSaveVisible] = useState(false);
  const [countries, setCountries] = useState([]);
  const [tableData, setTableData] = useState([]);

  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(permissions, pages["State"]["id"]);

  const fetchClasses = async (url) => {
    setapiloader(true);
    getAPI(
      url,
      (data) => {
        setstate(data["data"]);
        setTableData(data["data"]);
        setapiloader(false);
      },
      (data) => {
        failureToast(data["message"]);
      }
    );
  };

  const fetchCountry = async (url) => {
    setapiloader(true);
    getAPI(
      url,
      (data) => {
        const coutryList = data.data.map((data) => {
          const { id, countryDispValue, status } = data;
          if (status === "ACTIVE") {
            return {
              value: id,
              label: countryDispValue,
            };
          }
        });

        setCountries(coutryList);
      },
      (data) => {
        failureToast(data["message"]);
      }
    );
  };

  useEffect(() => {
    fetchClasses(masterServiceBaseUrl + "/state/getAllState");
    fetchCountry(masterServiceBaseUrl + "/country/getAllActiveCountry");
  }, []);

  const refreshList = () => {
    fetchClasses(masterServiceBaseUrl + "/state/getAllState");
  };

  return (
    <>
      {apiloader ? (
        <CustomLoader
          apiLoader={apiloader}
          loaderHeight={"200px"}
          loaderWidth={"100% "}
        />
      ) : (
        <Fragment>
          {userPermissions ? (
            <>
              <StateTable
                userPermissions={userPermissions}
                fetchClasses={fetchClasses}
                data={countries}
                setstate={setstate}
                state={state}
                tableData={tableData}
                countries={countries}
                isSaveVisible={isSaveVisible}
                setisSaveVisible={setisSaveVisible}
                refreshList={refreshList}
                apiLoader={apiloader}
              />
            </>
          ) : (
            <PermisionDenied />
          )}
        </Fragment>
      )}
    </>
  );
};
export default State;
